import { Component, ElementRef, OnInit } from '@angular/core';
import { InceptionService, TranslationService } from '@proximus/ng-common';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getPublicWifiUpdateAliasError,
  getPublicWifiUpdateAliasPending,
  getPublicWifiUpdateAliasSuccess,
  getPublicWifiUpdatePasswordError,
  getPublicWifiUpdatePasswordPending,
  getPublicWifiUpdatePasswordSuccess,
} from '../../store/reducers';
import {
  ResetPublicWifiManageValues,
  UpdatePublicWifiLoginAlias,
  UpdatePublicWifiPassword,
} from '../store/actions/public-wifi.actions';
import { Alert, AlertsService } from '@proximus/ng-common-components';
import { PublicWifiAccountFormDirective } from '../public-wifi-account-form/public-wifi-account-form.directive';

export enum ViewType {
  DEFAULT,
  EDIT_LOGIN,
  EDIT_PASSWORD,
}

@Component({
  selector: 'mprd-public-wifi-account-manage',
  templateUrl: './public-wifi-account-manage.component.html',
  styleUrls: ['./public-wifi-account-manage.component.css'],
})
export class PublicWifiAccountManageComponent
  extends PublicWifiAccountFormDirective
  implements OnInit
{
  ViewType = ViewType;
  selectedViewType = ViewType.DEFAULT;
  updateAliasPending = false;
  updatePasswordPending = false;

  constructor(
    private store: Store<ApplicationState>,
    private inceptionService: InceptionService,
    private elementRef: ElementRef,
    private translationService: TranslationService,
    private alertService: AlertsService,
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.store.select(getPublicWifiUpdateAliasPending).subscribe((res) => {
        if (
          this.getValueWithoutDomain(this.account.technicalLoginId) ===
          res.selectedTechnicalLoginId
        ) {
          this.updateAliasPending = res.value;
        }
      }),
    );
    this.addSubscription(
      this.store.select(getPublicWifiUpdateAliasSuccess).subscribe((res) => {
        if (this.shouldShowAlert(res)) {
          this.toggleDefault();
          this.account.login =
            this.login +
            this.translationService.getTranslatedValueFor(
              'publicWifi.accountList.manage.editMode.domainName',
            );
          this.showAlert(
            'publicWifi.accountList.manage.updateAlias.success.title',
            'publicWifi.accountList.manage.updateAlias.success.description',
            'success',
          );
        }
      }),
    );
    this.addSubscription(
      this.store.select(getPublicWifiUpdateAliasError).subscribe((res) => {
        if (this.shouldShowAlert(res)) {
          this.showAlert(
            'publicWifi.accountList.manage.updateAlias.error.title',
            'publicWifi.accountList.manage.updateAlias.error.description',
            'error',
          );
        }
      }),
    );
    this.addSubscription(
      this.store.select(getPublicWifiUpdatePasswordPending).subscribe((res) => {
        if (
          this.getValueWithoutDomain(this.account.technicalLoginId) ===
          res.selectedTechnicalLoginId
        ) {
          this.updatePasswordPending = res.value;
        }
      }),
    );
    this.addSubscription(
      this.store.select(getPublicWifiUpdatePasswordSuccess).subscribe((res) => {
        if (this.shouldShowAlert(res)) {
          this.toggleDefault();
          this.showAlert(
            'publicWifi.accountList.manage.updatePassword.success.title',
            'publicWifi.accountList.manage.updatePassword.success.description',
            'success',
          );
        }
      }),
    );
    this.addSubscription(
      this.store.select(getPublicWifiUpdatePasswordError).subscribe((res) => {
        if (this.shouldShowAlert(res)) {
          this.showAlert(
            'publicWifi.accountList.manage.updatePassword.error.title',
            'publicWifi.accountList.manage.updatePassword.error.description',
            'error',
          );
        }
      }),
    );
  }

  showAlert(
    title: string,
    desc: string,
    type: 'error' | 'info' | 'success' | 'warning',
  ) {
    setTimeout(() => {
      const alert: Alert = {
        isClosable: true,
        alertKey:
          'publicWifiUpdateAlert' +
          this.getValueWithoutDomain(this.account.technicalLoginId),
        title: this.translationService.getTranslatedValueFor(title),
        description: this.translationService.getTranslatedValueFor(desc),
        type,
      };
      this.alertService.dispatchAlert(alert);
      this.store.dispatch(new ResetPublicWifiManageValues());
      this.resetForm();
    });
  }

  toggleEditLogin() {
    this.selectedViewType = ViewType.EDIT_LOGIN;
    if (this.account.login) {
      this.login = this.getValueWithoutDomain(this.account.login);
    }
    this.validateLogin();
  }

  toggleEditPassword() {
    this.selectedViewType = ViewType.EDIT_PASSWORD;
    setTimeout(() => {
      this.inceptionService.forms(this.elementRef);
    });
  }

  toggleDefault() {
    this.selectedViewType = ViewType.DEFAULT;
  }

  saveLogin() {
    const loginToSave = this.login;
    this.store.dispatch(
      new UpdatePublicWifiLoginAlias({
        technicalLoginId: this.getValueWithoutDomain(
          this.account.technicalLoginId,
        ),
        login: loginToSave,
        oldLogin: this.getValueWithoutDomain(this.account.login),
      }),
    );
  }

  savePassword() {
    this.store.dispatch(
      new UpdatePublicWifiPassword({
        technicalLoginId: this.getValueWithoutDomain(
          this.account.technicalLoginId,
        ),
        password: this.password,
      }),
    );
  }

  cancel() {
    this.toggleDefault();
    this.resetForm();
  }
}
